/**
 * services/adminDrawings.js — Admin (foundation-KB scoped) drawings client.
 * Mirrors the portal `drawings.js` client but talks to the admin routes.
 */
import axios from 'axios';
import { useAdminStore } from '../stores';

const client = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 120000,
});
client.interceptors.request.use((cfg) => {
  const tok = useAdminStore.getState().token;
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`;
  return cfg;
});

export const adminDrawingsApi = {
  list: (kbId) => client.get(`/admin/foundation-kb/${kbId}/drawings`),
  get: (id) => client.get(`/admin/foundation-drawings/${id}`),
  remove: (id) => client.delete(`/admin/foundation-drawings/${id}`),
  upload: (kbId, file, onProgress) => {
    const form = new FormData();
    form.append('file', file);
    return client.post(`/admin/foundation-kb/${kbId}/drawings/upload`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    });
  },
  thumbUrl: (id) => `${process.env.REACT_APP_BACKEND_URL}/api/admin/foundation-drawings/${id}/thumb`,
};
